export default "__VITE_ASSET__kIp8U73U__"